import { useMutation, useQuery } from "react-query";
import { useDispatch } from "react-redux";
import axios from "axios";
import _ from "lodash";

import { WEATHER_TABLE_CONFIG } from "../Constants/datatables";
import { useDataTableContext } from "../pages/Contexts/DataTableContext";
import { resetWeatherStates, setIsEditingWeather } from "../redux/Slices/Apps/appsSlice";
import { handleResErrors, useInvalidateCampaignLayer } from "./utils";
import { useCustomToast } from "../pages/Contexts/ToastContext";
import { toggleDialog } from "../redux/Slices/Global/globalSlice";
import axiosInstance from "../config/Axios";

const BASE_URL = process.env.REACT_APP_NOT_SECRET_CODE

//--------------------------Read Weather--------------------------
const readWeather = async (payload) => {

    const response = await axios.post(`${BASE_URL}/weather/read`, payload,
        {
            headers: {
                'Authorization': `Bearer ${payload?.token || localStorage.getItem("access_token")}`,
            },
        }
    );
    return response.data;
};

export const useReadWeather = () => {
    return useMutation(readWeather);
};

//--------------------------Read media path---------------------------
const fetchMediaPath = async ({ queryKey }) => {
    const [_key, payload] = queryKey;

    const response = await axios.get(`${BASE_URL}/weather/${payload?.id}/media/path`, {
        headers: {
            Authorization: `Bearer ${payload?.token || localStorage.getItem("access_token")}`,
        },
    });

    return response.data;
};



export const useFetchMediaPath = (payload) => {
    return useQuery({
        queryKey: ['fetchMediaPath', payload],
        queryFn: fetchMediaPath,
        refetchInterval: 24 * 60 * 60 * 1000, // 24 hours  
        enabled: !!payload?.id && !!payload?.token,
    });
};

//--------------------------Read Weather external--------------------------
const readWeatherExternal = async ({ queryKey }) => {
    const [_key, payload] = queryKey;
    const response = await axios.post(`${BASE_URL}/weather/read`, payload, {
        headers: {
            'Authorization': `Bearer ${payload?.token || localStorage.getItem("access_token")}`,
        },
    });
    return response.data;
};



export const useReadWeatherExternal = (payload) => {
    return useQuery({
        queryKey: ['readWeatherExternal', payload],
        queryFn: readWeatherExternal,
        refetchInterval: 24 * 60 * 60 * 1000, // 24 hours  
        enabled: !!payload?.media_id && !!payload?.token,
    });
};



//--------------------------Create Weather--------------------------
const createWeather = async (payload) => {
    const { data } = await axiosInstance.post("/weather/create", payload);
    return data.data;
}

export const useCreateWeatherMutation = () => {
    const { showToast } = useCustomToast();
    const dispatch = useDispatch()
    const { setLazyParams } = useDataTableContext();

    return useMutation(createWeather, {
        onSuccess: async (data) => {
            dispatch(toggleDialog("WeatherDialog"))
            dispatch(resetWeatherStates())
            showToast('success', "Weather Handling", data?.msg);
            setLazyParams(prev => ({ ...prev, ...WEATHER_TABLE_CONFIG }))
        },
        onError: (error) => handleResErrors(error, showToast)
    })
}

//--------------------------Update Weather--------------------------
const updateWeather = async (payload) => {
    const { data } = await axiosInstance.post(`/weather/${payload?.id}/update`, payload);

    return data.data;
}

export const useUpdateWeatherMutation = () => {
    const { showToast } = useCustomToast();
    const { setLazyParams } = useDataTableContext();
    const dispatch = useDispatch()
    const pathName = window.location.pathname;
    const invalidateCampaignLayer = useInvalidateCampaignLayer();

    return useMutation(updateWeather, {
        onSuccess: async (data) => {
            setLazyParams(prev => ({ ...prev, ...WEATHER_TABLE_CONFIG }))
            dispatch(resetWeatherStates())
            if (pathName.includes('campaign') || pathName.includes('layouts')) {
                invalidateCampaignLayer()
            }
            dispatch(toggleDialog("WeatherDialog"))
        },
        onError: (error) => handleResErrors(error, showToast)

    })
}